import React from 'react';
import Layout from '../../components/Layout/Layout';
import GoBack from '../../components/pages/NotFound/GoBack/GoBack';

const NotFoundPage:React.FC = () => {

		return (
			<Layout>
				<GoBack />
			</Layout>
	)
};

export default NotFoundPage;
